import type { PatientWithAppointmentApi } from "@/Modules/Models/Api/Schedule";

import { isValidString } from "@/Utils/String";

import { get2 } from "./utils/FunctionalTherapyApi";

export function get(sort?: "username" | "-username"): Promise<PatientWithAppointmentApi[]> {
  return get2<void, PatientWithAppointmentApi[]>(
    `v1.0/patients?${isValidString(sort) ? `ordering=${sort}` : ""}`
  );
}
